let $ = require('jquery');
let Promise = require('bluebird');

let search = require('./ui/search');
let quickCustomer = require('./ui/quick-customer');
let niceScroll = require('./ui/nice-scroll');
let utils = require('./ui/utils');

/**
 * Helper responsavel pela estilização de elementos
 * naturais feitos sob a estrutura do SCI e não
 * elementos third-party
 */
let ui = (self = $(document)) => Promise.all([
    search(self),
    quickCustomer(self),
    niceScroll(self),
    utils(self)
]);

module.exports = ui;



// WEBPACK FOOTER //
// ./resources/assets/javascript/sci/ui.js